<div class="header-top-row">
  @if (contactVariable$ | async; as contactVars) {
    <a class="phone-link" target="new" [href]="'tel:' + contactVars.contactPhoneLinked">
      <i class="fa fa-phone-alt"></i>&nbsp;
      {{ contactVars.contactPhoneDisplayed }}
    </a>
  }
  <div class="top-navigation">
    @if (isLoggedIn && isStudent) {
      <a [routerLink]="['/Misc_Pricing'] | localize">
        <span translate>texts.HeaderSection_prices</span>
      </a>
    }
    @if (isTeacher && !showTutorGuideButton) {
      <a [routerLink]="['/Misc_tutor_academy'] | localize">
        <span translate>texts.Navigation_Tutor_Academy</span>
      </a>
    }
    @if (!isLoggedIn) {
      <a [routerLink]="['/Misc_become_tutor'] | localize">
        <span translate>texts.NavigationSection_become_a_tutor</span>
      </a>
    }
    @if (isTeacher) {
      <a [routerLink]="['/Navigation_tutor_bonus'] | localize">
        {{ 'texts.NavigationSection_tutor_bonus' | translate }}
      </a>
    }
    @if (!isLoggedIn || !isTeacher) {
      <a [routerLink]="['/Navigation_faq'] | localize">
        {{ 'texts.NavigationSection_faq' | translate }}
      </a>
    }
    <a [routerLink]="['/Misc_about_us'] | localize">
      {{ 'texts.NavigationSection_team' | translate }}
    </a>
    <a [routerLink]="['/Misc_contact'] | localize">
      {{ 'texts.NavigationSection_contact' | translate }}
    </a>
  </div>
</div>
